import styled from 'styled-components'
import { formatPriceNoCurrencySymbol } from '@dmi-mch/utils'
import { useModuleContext } from '../contexts/module'

const ArtworkPrice = () => {
  const { state: { artworkInformation } } = useModuleContext()
  const {
    showPrice,
    isSold,
    labelNotAvailable,
    priceInSecondCurrency,
    priceRange,
    secondCurrency,
    reservedArtwork,
    price,
    labels,
    labelExcludedTaxes
  } = artworkInformation || {}
  return (
    <ArtworkPriceStyled invisible={showPrice} className='col-12 col-lg-12 mt-2'>
      {isSold
        ? (
          <div className='text-small pt-2'> {labelNotAvailable}</div>
        )
        : (
          <>
            {priceInSecondCurrency && (
              <Price className='color-black h5'>
                {secondCurrency} {formatPriceNoCurrencySymbol(priceInSecondCurrency)}
              </Price>
            )}
            {!priceInSecondCurrency && (
              <Price className='color-black h5'>
                {priceRange ?? `USD ${formatPriceNoCurrencySymbol(price)}`}
              </Price>
            )}
            {reservedArtwork && (<span> | {labels?.OnlineShowRoom?.reservedArtworkLabel || 'Reserved'}</span>)}
            {!priceRange &&
              <div
                className='text-small color-black pt-2'
              >
                {labelExcludedTaxes}
              </div>
            }
          </>
        )
      }
    </ArtworkPriceStyled>
  )
}

const ArtworkPriceStyled = styled.div<any>`
  display: ${({
  invisible
}) => (invisible ? 'none' : 'block')};
`

const Price = styled.h3<any>`
  display: inline-block;
`

export default ArtworkPrice